"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cb = exports.GLOBAL_CB = void 0;
var GLOBAL_CB = '@@one-portal/cb';
exports.GLOBAL_CB = GLOBAL_CB;
var Cb = function Cb() {
  var callbacks = {};
  var uuid = 0;
  return {
    __autoRun: function __autoRun() {
      var _this = this;
      window.addEventListener('message', function (message) {
        if (message.data.type && message.data.type === '@@cb.request.callback') {
          var _message$data = message.data,
            callbackId = _message$data.callbackId,
            payload = _message$data.payload;
          var __cb = callbacks[callbackId];
          __cb && __cb.call(_this, payload);
        }
      });
    },
    autoRun: function autoRun(callback) {
      var callbackId = ++uuid;
      callbacks[callbackId] = callback;
      return {
        callbackId: callbackId
      };
    },
    get: function get(id) {
      return callbacks[id];
    }
  };
};

// ensure singleton
if (!window[GLOBAL_CB]) {
  window[GLOBAL_CB] = Cb();
}
var cb = window[GLOBAL_CB];

// auto run
exports.cb = cb;
cb.__autoRun();